import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Contact, HeartBroken, RealTrends, socialNetworks as socialnetworksIcons, } from "../icons";
import { readableColor } from "polished";
import styled from "@emotion/styled";
import { colors } from "../theme";
import { Trans } from "@lingui/react";
import { useElementsContext } from "../elementsProvider";
export function RTCFooter({ backgroundColor, email, homeUrl, htmlAfip, language, logoColor, logoContent, logoImage, logoType, logoTypography, menu, phoneNumber, phoneNumberURI, renderLink, showContact, showNavigation, skin, socialNetworks, typographyTexts, storeId, }) {
    const { isMobile } = useElementsContext();
    const logoImageParse = logoImage != null && logoImage !== ""
        ? JSON.parse(logoImage)
        : undefined;
    return (_jsxs(Container, { children: [_jsx(Meta, Object.assign({ backgroundColor: backgroundColor, isDesktop: !isMobile }, { children: _jsxs(MetaContent, Object.assign({ skin: skin, isDesktop: !isMobile, phoneNumber: phoneNumber, socialNetworks: socialNetworks.length, email: email }, { children: [logoType === "T" && (_jsx(Logo, Object.assign({ color: logoColor, typography: logoTypography, isDesktop: !isMobile }, { children: _jsx("a", Object.assign({ href: homeUrl, title: logoContent }, { children: logoContent }), void 0) }), void 0)),
                        logoType === "I" && (_jsx(LogoImage, Object.assign({ isDesktop: !isMobile }, { children: _jsx("img", { src: logoImageParse === null || logoImageParse === void 0 ? void 0 : logoImageParse.medium, alt: "Logo de tu marca" }, void 0) }), void 0)),
                        socialNetworks.length > 0 && (_jsx(SocialNetworks, Object.assign({ skin: skin, isDesktop: !isMobile }, { children: socialNetworks.map(socialNetwork => (_jsx(SocialNetwork, Object.assign({ href: socialNetwork.url, target: "_blank", title: socialNetwork.title, backgroundColor: backgroundColor, isDesktop: !isMobile }, { children: socialnetworksIcons[socialNetwork.iconName] }), socialNetwork.id))) }), void 0)),
                        email !== "" && language === "es-AR" && (_jsxs(CancelPurchaseButton, Object.assign({ isDesktop: !isMobile, backgroundColor: backgroundColor, href: `mailto:${email}` }, { children: [_jsx(HeartBroken, {}, void 0),
                                _jsx(Trans, { id: "Me arrepent\u00ED de mi compra" }, void 0)] }), void 0)),
                        showNavigation && (_jsx(Navigation, { children: _jsx(NavigationList, Object.assign({ skin: skin, isDesktop: !isMobile }, { children: menu.map(({ id, title, href, type }) => (_jsx(NavigationItem, Object.assign({ isDesktop: !isMobile }, { children: _jsx(NavigationLink, Object.assign({ backgroundColor: backgroundColor, typographyTexts: typographyTexts }, { children: type === "L" || renderLink == null ? (_jsx("a", Object.assign({ title: title, href: href }, (type === "L"
                                            ? { rel: "noopener noreferrer", target: "_blank" }
                                            : {}), { children: title }), void 0)) : (renderLink({ title, href })) }), void 0) }), id))) }), void 0) }, void 0)),
                        showContact && (_jsxs(ContactContainer, Object.assign({ href: phoneNumberURI, title: phoneNumber, backgroundColor: backgroundColor, typographyTexts: typographyTexts, isDesktop: !isMobile }, { children: [phoneNumber && _jsx(Contact, {}, void 0), phoneNumber] }), void 0)),
                        _jsx(HtmlAFIP, { dangerouslySetInnerHTML: {
                                __html: htmlAfip,
                            } }, void 0)] }), void 0) }), void 0),
            _jsx(Trademark, Object.assign({ isDesktop: !isMobile }, { children: _jsx(TrademarkContent, Object.assign({ isDesktop: !isMobile }, { children: _jsxs(MadeByLink, Object.assign({ href: `https://www.real-trends.com/ar/?utm_source=footer-shop&utm_medium=${storeId}`, rel: "noreferrer", target: "_blank" }, { children: [_jsx(CopyrightText, { children: _jsx(Trans, { id: "Tienda creada con " }, void 0) }, void 0),
                            _jsx(MadeByLogo, { children: _jsx(RealTrends, {}, void 0) }, void 0)] }), void 0) }), void 0) }), void 0)] }, void 0));
}
const Container = styled.footer(() => ({
    display: "flex",
    flexDirection: "column",
}));
const Meta = styled.div(({ backgroundColor, isDesktop }) => (Object.assign({ backgroundColor }, (isDesktop
    ? {
        display: "grid",
        gridTemplateAreas: "'. content .'",
        gridTemplateColumns: "1fr 960px 1fr",
    }
    : {}))));
const MetaContent = styled.div(({ skin, isDesktop, phoneNumber, socialNetworks, email }) => {
    let gridTemplateAreas;
    let gridTemplateAreasMobile;
    let justifyItems;
    switch (skin) {
        case "2":
            const dynamicAreas2 = [];
            dynamicAreas2[email ? "unshift" : "push"]("button");
            dynamicAreas2[socialNetworks > 0 ? "unshift" : "push"]("socials");
            dynamicAreas2[phoneNumber ? "unshift" : "push"]("contact");
            gridTemplateAreas = `"logo navigation ${dynamicAreas2[0]} fiscal"
                          "logo navigation ${dynamicAreas2[1]} fiscal"
                          "logo navigation ${dynamicAreas2[2]} fiscal"`;
            gridTemplateAreasMobile = `"logo"
                                "navigation"
                                "contact"
                                "socials"
                                "button"
                                "fiscal"`;
            justifyItems = "start";
            break;
        default:
            // skin 1
            const dynamicAreas1 = [];
            dynamicAreas1[email ? "unshift" : "push"]("button");
            dynamicAreas1[phoneNumber ? "unshift" : "push"]("contact");
            gridTemplateAreas = `"logo navigation ${dynamicAreas1[0]} fiscal"
                              "socials navigation ${dynamicAreas1[1]} fiscal"`;
            gridTemplateAreasMobile = `"logo"
                                "socials"
                                "navigation"
                                "contact"
                                "button"
                                "fiscal"`;
            justifyItems = "center";
            break;
    }
    return Object.assign({ alignItems: "center", display: "grid", gridGap: "3.2rem", justifyItems, padding: "2.4rem 1.6rem 0 1.6rem", gridTemplateAreas: gridTemplateAreasMobile, justifyContent: "center" }, (isDesktop
        ? {
            justifyContent: "normal",
            alignItems: "start",
            gridArea: "content",
            gridGap: "3.2rem",
            gridTemplateAreas,
            justifyItems: "start",
            padding: "3.6rem 0",
        }
        : {}));
});
const Logo = styled.div(({ color, typography, isDesktop }) => (Object.assign({ "& a": {
        color,
        fontFamily: typography,
        fontSize: "3.6rem",
        lineHeight: 1,
        textDecoration: "none",
    }, gridArea: "logo", maxWidth: "25rem", wordBreak: "break-word" }, (isDesktop
    ? {
        maxWidth: "35.2rem",
    }
    : {}))));
const LogoImage = styled.div(({ isDesktop }) => ({
    "& img": {
        maxHeight: "7.2rem",
        maxWidth: "15rem",
    },
    gridArea: "logo",
}));
const SocialNetworks = styled.div(({ skin, isDesktop }) => {
    let justifyContent;
    let maxWidth;
    switch (skin) {
        case "2":
            justifyContent = "flex-start";
            maxWidth = "28rem";
            break;
        default:
            // skin 1
            justifyContent = "center";
            maxWidth = "28rem";
            break;
    }
    return Object.assign({ listStyle: "none", padding: "0", display: "flex", flexWrap: "wrap", maxWidth, margin: "-0.8rem", justifyContent, gridArea: "socials" }, (isDesktop
        ? {
            justifyContent: "flex-start",
            maxWidth: "28rem",
        }
        : {}));
});
const SocialNetwork = styled.a(({ backgroundColor, isDesktop }) => (Object.assign({ alignItems: "center", backgroundColor: readableColor(backgroundColor), borderRadius: "50%", color: backgroundColor, display: "flex", justifyContent: "center", margin: "1.2rem", padding: "0.8rem", textDecoration: "none", "& > svg": {
        color: "inherit",
        fontSize: "2rem",
    } }, (isDesktop
    ? {
        "&:hover": {
            opacity: "0.6",
        },
    }
    : {}))));
const Link = styled.a(() => ({
    color: "inherit",
    fontSize: "1.6rem",
    textDecoration: "none",
}));
const NavigationList = styled.ul(({ skin, isDesktop }) => {
    let justifyItems;
    switch (skin) {
        case "2":
            justifyItems = "start";
            break;
        default:
            // skin 1
            justifyItems = "center";
            break;
    }
    return Object.assign({ display: "grid", gridArea: "navigation", gridGap: "0.8rem", justifyItems, listStyle: "none", margin: 0, padding: 0 }, (isDesktop
        ? {
            justifyItems: "start",
        }
        : {}));
});
const NavigationItem = styled.li(({ isDesktop }) => (Object.assign({ textAlign: "center" }, (isDesktop
    ? {
        "&:hover": {
            opacity: "0.6",
        },
    }
    : {}))));
const NavigationLink = styled.span(({ backgroundColor, typographyTexts }) => ({
    color: readableColor(backgroundColor),
    fontFamily: typographyTexts,
    "& > a": { color: "inherit", fontSize: "1.6rem", textDecoration: "none" },
}));
const ContactContainer = styled(Link)(({ backgroundColor, typographyTexts, isDesktop }) => (Object.assign({ alignItems: "center", color: readableColor(backgroundColor), display: "grid", fontFamily: typographyTexts, gridArea: "contact", gridAutoFlow: "column", gridGap: "0.8rem" }, (isDesktop
    ? {
        "&:hover": {
            opacity: "0.6",
        },
    }
    : {}))));
const Trademark = styled.div(({ isDesktop }) => (Object.assign({ backgroundColor: colors.greyMedium }, (isDesktop
    ? {
        display: "grid",
        gridTemplateAreas: "'. content .'",
        gridTemplateColumns: "1fr 960px 1fr",
    }
    : {}))));
const TrademarkContent = styled.div(({ isDesktop }) => (Object.assign({ alignItems: "center", color: colors.white, display: "grid", fontFamily: "Open Sans, sans-serif", fontSize: "1rem", gridGap: "0.4rem", gridTemplateRows: "50% 50%", height: "10rem", padding: "2.4rem 2rem 3.2rem 2rem", textAlign: "center" }, (isDesktop
    ? {
        alignItems: "center",
        display: "flex",
        gridArea: "content",
        gridGap: "0.8rem",
        height: "4.8rem",
        justifyContent: "space-between",
        padding: "1.8rem 0",
    }
    : {}))));
const MadeByLink = styled.a(() => ({
    alignItems: "center",
    display: "grid",
    gridAutoFlow: "column",
    gridGap: "0.8rem",
    justifyContent: "center",
    fontsize: "1.2rem",
    textDecoration: "none",
}));
const MadeByLogo = styled.span(() => ({
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    fontSize: "5.6rem",
    color: "white",
    "& svg": {
        height: "0.5em",
    },
}));
const HtmlAFIP = styled.span(() => ({
    gridArea: "fiscal",
    width: "6.4rem",
    marginBottom: "4.8rem",
    "& img": {
        width: "100%",
    },
}));
const CopyrightText = styled.span(() => ({
    color: colors.white,
    fontSize: "1.2rem",
    fontFamily: "Open Sans, sans-serif",
}));
const CancelPurchaseButton = styled.a(({ backgroundColor, isDesktop }) => (Object.assign({ alignItems: "center", color: readableColor(backgroundColor), cursor: "pointer", display: "flex", fontSize: "1.2rem", gridArea: "button", justifyContent: "center", textDecoration: "none", "& > svg": {
        color: "inherit",
        fontSize: "1.6rem",
        marginRight: "0.8rem",
    } }, (isDesktop
    ? {
        "&:hover": {
            opacity: "0.6",
        },
    }
    : {}))));
const Navigation = styled.nav();
//# sourceMappingURL=RTCFooter.js.map